import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginType } from '../../classes/static/enums';
import { LoginService } from '../../services/login.service';
import { CardModalComponent } from '../card-modal/card-modal.component';
import { ConnectProfileModalComponent } from '../connect-profile-modal/connect-profile-modal.component';
import { ContactInfoModalComponent } from '../contact-info-modal/contact-info-modal.component';
import { CreatePasswordComponent } from '../create-password/create-password.component';
import { ForgetCredentialsRetailModalComponent } from '../forget-credentials-retail-modal/forget-credentials-retail-modal.component';
import { IBankCredentialsModalComponent } from '../ibank-credentials-modal/ibank-credentials-modal.component';
import { PasswordRetrievalComponent } from '../password-retrieval/password-retrieval.component';

@Component({
	selector: 'retail-login-form',
	template: require('./retail-login-form.component.html'),
})
export class RetailLoginFormComponent {
	isFirstStep: boolean = true;
	existingUser: boolean = false;
	@Input() isCorporateUser: boolean = false;
	@Input() isDisabled: boolean = true;
	// we use this boolean to show the error
	// message when a user is corporate
	//isCorporateUser: boolean = false;
	userId: string = '';
	isPasswordVisible: boolean = false;

	constructor(private modalService: NgbModal, private router: Router) {}

	submitCode(): void {
		this.isFirstStep = false;
	}

	backToFirstStep() {
		this.isFirstStep = true;
	}

	toggleVisibility() {
		this.isPasswordVisible = !this.isPasswordVisible;
	}

	toggleNewPassword() {
		this.modalService.open(CreatePasswordComponent, {
			windowClass: 'modal-small',
		});
	}
	corporateSelected() {
		LoginService.setType(LoginType.Corporate);
	}

	// toggleForgetPassword() {
	//   this.modalService.open(MessageModalComponent, {
	//     windowClass: "modal-small",
	//   });
	// }

	togglePasswordRetrievalModal() {
		this.modalService.open(PasswordRetrievalComponent, {
			windowClass: 'modal-small',
		});
	}

	toggleContactInfoModal() {
		this.modalService.open(ContactInfoModalComponent, {
			windowClass: 'modal-small',
		});
	}

	toggleCardModal() {
		this.modalService.open(CardModalComponent, {
			windowClass: 'modal-small',
		});
	}

	public learnMore(type: string) {
		switch (type) {
			case 'register-nbg':
				window.open('https://microsites.nbg.gr/CustomeronBoarding/index.html', '_blank');
				break;
			case 'register-ibank':
				window.open('https://microsites.nbg.gr/mobilebanking/index_CO.html', '_blank');
				break;
		}
	}

	public toggleIBankCredentials(): void {
		this.modalService.open(IBankCredentialsModalComponent, {
			windowClass: 'modal-small',
		});
	}

	toggleForgetModal() {
		this.modalService.open(ForgetCredentialsRetailModalComponent, {
			windowClass: 'modal-small',
		});
	}

	// toggleBusinessRegistrationInfoModal() {
	//   this.modalService.open(BusinessRegistrationInfoModalComponent, {
	//     windowClass: "modal-small",
	//   });
	// }

	onSubmit(): void {
		this.modalService.open(ConnectProfileModalComponent, {
			windowClass: 'modal-small',
		});
	}
	routeBus(): void {
		//this.loginService.toggleSetting(false);
	}
}
